import { useTranslation } from "react-i18next"
import { Satellite } from "lucide-react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"
import { useUserPermissions } from "@/hooks/useUserPermissions"

const GpsManagementSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const { hasPermission, loading } = useUserPermissions()

  if (loading || !hasPermission("gps.manage_providers")) {
    return null
  }

  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.GPS_MANAGEMENT}
      icon={Satellite}
      activeIcon={Satellite}
      tooltipText={t("app.sidebar.gpsProviders")}
      className={className}
    />
  )
}

export default GpsManagementSidebarButton
